module.exports = new __parcel__URL__("empty-add-item.21249b5f.svg").toString();